import React from "react";
import DynamicCheckbox, {
  DynamicCheckboxComp126,
  DynamicCheckboxComp4,
  DynamicCheckboxComp6,
  DynamicCheckboxComp12,
} from "./DynamicCheckbox";

export function CustomCheckBox({ title, data }) {
  const isExcluded = checkExclusion(data);
  return <DynamicCheckboxComp4 label={title} isChecked={isExcluded} />;
}
export function CustomCheckBoxComp6({ title, data }) {
  const isExcluded = checkExclusion(data);
  return <DynamicCheckboxComp6 label={title} isChecked={isExcluded} />;
}
export function CustomCheckBoxComp126({ title, data }) {
  const isExcluded = checkExclusion(data);
  return <DynamicCheckboxComp126 label={title} isChecked={isExcluded} />;
}
export function CustomCheckBoxComp12({ title, data }) {
  const isExcluded = checkExclusion(data);
  return <DynamicCheckboxComp12 label={title} isChecked={isExcluded} />;
}
// Function to check the exclusion condition
const checkExclusion = (data) => {
  return data === "F" || data == null || data === ""|| data === false  ? false : true;
};
